import { render } from "./adduser_page.vue?vue&type=template&id=1502b69e"
import script from "./adduser_page.vue?vue&type=script&lang=js"
export * from "./adduser_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__